<template>
  <!--
    bootstrap-vueの<b-nav tabs>を使い、純粋なタブナビゲーションを実装します。
    このコンポーネントはコンテンツの表示には関与しません。
  -->
  <BNav tabs>
    <BNavItem
      v-for="tab in tabs"
      :key="tab.key"
      :active="modelValue === tab.key"
      @click.prevent="handleTabClick(tab.key)"
      href="#"
    >
      {{ tab.title }}
    </BNavItem>
  </BNav>
</template>

<script setup>
/**
 * AppTabs - タブナビゲーションコンポーネント (Organism)
 *
 * アプリケーション全体で使用される再利用可能なタブナビゲーションです。
 * Bootstrap Vueのb-navコンポーネントをラップして、
 * アプリケーション固有のタブ機能を提供します。
 *
 * 責務:
 * - タブナビゲーションのUI描画
 * - アクティブタブの視覚的表示
 * - タブクリック時の親コンポーネントへの通知
 * - v-modelによる双方向バインディング対応
 */

defineProps({
  /**
   * 表示するタブのリスト
   * 例: [{ key: 'info', title: '各種情報設定' }, ...]
   */
  tabs: {
    type: Array,
    default: () => [],
    validator: (tabs) => {
      return tabs.every(tab =>
        tab &&
        typeof tab.key === 'string' &&
        typeof tab.title === 'string'
      )
    }
  },
  /**
   * 現在アクティブなタブのキー（v-modelで使用）
   * Vue 3では`modelValue`プロパティを使用
   */
  modelValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

/**
 * タブがクリックされたときに、親コンポーネントにキーを通知します
 * @param {string} key - クリックされたタブのキー
 */
const handleTabClick = (key) => {
  /**
   * @event update:modelValue
   * @type {string} クリックされたタブのキー
   */
  emit('update:modelValue', key)
}
</script>

<style scoped>
/* b-nav-itemのクリックカーソルをポインターにします */
.nav-tabs .nav-link {
  cursor: pointer;
}
</style>
